import { render, staticRenderFns } from "./AmResponsive.vue?vue&type=template&id=8c1ad00a&scoped=true&"
import script from "./AmResponsive.vue?vue&type=script&lang=js&"
export * from "./AmResponsive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1ad00a",
  null
  
)

export default component.exports